module.exports = __webpack_public_path__ + "static/media/YL_no1innovtor_EN.e85558de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/YL_no1innovtor_EN.png
// module id = 1273
// module chunks = 0